import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./interfaces";
import { Actions } from "./styles";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";
import { MyTeamPayrollOutputDocumentsContext } from "../../../../views/documents-reports/MyTeamPayrollOutputReport/MyTeamPayrollOutputReport";
import AddNewDocument from "../../../AddNewDocument/AddNewDocument";

const DocReportCellActions = ({ handleNotifyTable, documentFieldsProps, hasDeadline = false }: Props) => {
  const { t } = useTranslation();

  const { userIsClient } = useContext(MyTeamPayrollOutputDocumentsContext);

  const [closePopover, setClosePopover] = useState<boolean>(false);

  const handleNotify = () => {
    setClosePopover(true);
    // close pop-over then notify the parent page
    handleNotifyTable();
    setClosePopover(false);
  };

  return (
    <SimplePopover
      buttonType="icon"
      buttonContent={<FontAwesomeIcon icon={faEllipsisV} />}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      shouldClose={closePopover}
      customButtonStyle={{ visibility: (userIsClient && hasDeadline) || !userIsClient ? "visible" : "hidden" }}
    >
      <Actions>
        {!userIsClient && (
          <AddNewDocument
            openButtonKey={`${t("buttons.add")} ${
              documentFieldsProps?.type ? `"${documentFieldsProps?.type.name}"` : ""
            }`}
            buttonType="text"
            variant="text"
            handleNotifyParent={handleNotify}
            documentFieldsProps={documentFieldsProps}
            allowMarkVerified
          />
        )}
        {hasDeadline && (
          <>
            <Button variant="text">{`${t("buttons.dismiss_reminder")}`}</Button>
            <Button>{`${t("buttons.remind_later")}`}</Button>
          </>
        )}
      </Actions>
    </SimplePopover>
  );
};

export default DocReportCellActions;
